import { useContext } from 'react';

import { ShopperContext } from './index';

export function useShopper() {
  return useContext(ShopperContext);
}
